// src/components/dashboard/NotificationsPanel.jsx
import { useState } from 'react';
import { C } from '../../styles/tokens';

const NOTIFICATIONS = [
  { icon: '🎉', text: 'Your application to TechFlow moved to Interview stage', time: '2h ago',  unread: true  },
  { icon: '🪙', text: '50 ONT tokens received as referral bonus',              time: '5h ago',  unread: true  },
  { icon: '📜', text: 'Certificate issued: React Advanced Patterns',           time: '1d ago',  unread: false },
  { icon: '✅', text: 'KYC verification approved — profile now verified',      time: '5d ago',  unread: false },
  { icon: '🤖', text: 'Your CV score improved to 73% after optimization',      time: '6d ago',  unread: false },
];

export default function NotificationsPanel() {
  const [notifications, setNotifications] = useState(NOTIFICATIONS);
  const unreadCount = notifications.filter(n => n.unread).length;

  const markAllRead = () => {
    setNotifications(prev => prev.map(n => ({ ...n, unread: false })));
  };

  const markRead = (i) => {
    setNotifications(prev => prev.map((n, idx) => idx === i ? { ...n, unread: false } : n));
  };

  return (
    <div className="card" style={{ padding: '22px' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <h3 className="syne" style={{ fontSize: '15px', fontWeight: 700 }}>Notifications</h3>
          {unreadCount > 0 && (
            <span style={{ width: '20px', height: '20px', borderRadius: '50%', background: `linear-gradient(135deg,${C.magenta},${C.violet})`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 800, fontFamily: "'Syne',sans-serif" }}>
              {unreadCount}
            </span>
          )}
        </div>
        {unreadCount > 0 && (
          <span
            onClick={markAllRead}
            style={{ fontSize: '11px', color: C.magenta, cursor: 'pointer', fontWeight: 600 }}
          >
            Mark all read
          </span>
        )}
      </div>

      {/* Notification list */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {notifications.map((n, i) => (
          <div
            key={i}
            onClick={() => markRead(i)}
            style={{
              display: 'flex', gap: '10px',
              padding: '11px 12px', borderRadius: '9px',
              background: n.unread ? 'rgba(254,52,232,.05)' : 'rgba(255,255,255,.02)',
              border: n.unread ? '1px solid rgba(254,52,232,.15)' : '1px solid rgba(255,255,255,.04)',
              cursor: 'pointer', transition: 'all .2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.background = n.unread ? 'rgba(254,52,232,.08)' : 'rgba(255,255,255,.04)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = n.unread ? 'rgba(254,52,232,.05)' : 'rgba(255,255,255,.02)'; }}
          >
            {/* Unread dot */}
            <div style={{ width: '7px', flexShrink: 0, paddingTop: '5px' }}>
              {n.unread && (
                <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: C.magenta, animation: 'pulse 1.5s ease-in-out infinite' }} />
              )}
            </div>

            {/* Icon */}
            <span style={{ fontSize: '17px', flexShrink: 0 }}>{n.icon}</span>

            {/* Text */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ fontSize: '12.5px', lineHeight: 1.5, color: n.unread ? 'rgba(255,255,255,.82)' : 'rgba(255,255,255,.45)' }}>
                {n.text}
              </p>
              <span style={{ fontSize: '10px', color: 'rgba(255,255,255,.22)', marginTop: '2px', display: 'block' }}>
                {n.time}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* View all */}
      <button style={{ width: '100%', padding: '10px', background: 'rgba(255,255,255,.03)', border: '1px solid rgba(255,255,255,.08)', borderRadius: '9px', color: 'rgba(255,255,255,.45)', fontSize: '12px', fontWeight: 600, cursor: 'pointer', marginTop: '10px', transition: 'all .2s' }}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,.07)'; e.currentTarget.style.color = '#fff'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,.03)'; e.currentTarget.style.color = 'rgba(255,255,255,.45)'; }}>
        View All Notifications
      </button>
    </div>
  );
}
